import React, { Component } from 'react'
import { connect } from 'react-redux';
import withAppShell from '../../hoc/withAppShell/WithAppShell';
import { PricingComponent, PaymentNotifierComponent } from '.'
import { PricingActions } from "../../../store";
import spinner from "../../ui/icons/spinner.gif";
import { MuiTypography } from '../../ui/MaterialUIComponents'
import theme from "../../../assests/theme"

const Paddle = window.Paddle;

class PricingContainer extends Component {

  constructor(props) {
    super(props);
    this.props.getSubscriptionPlans();
    this.state = {
      showPaymentNotifier: false
    }
  }
  componentWillMount() {

  }
  componentDidMount() {
  }

  getSubscription = (event, planId) => {
    event.preventDefault();
    Paddle.Checkout.open({
      product: planId,
      passthrough: { schoolId: '5d60d5792c632100389bc0b6' },
      successCallback: (data, err) => {
        let message = undefined;
        if (data.completed) {
          message = 'Payment SuccessFul'
        } else {
          message = 'Payment Failed'
        }
        this.setState({
          showPaymentNotifier: true,
          message: message
        })
      }
    });
  };


  render() {
    return <div style={{ width: '100%' }}>
      {!this.state.showPaymentNotifier ? (this.props.subscriptionPlans && this.props.subscriptionPlans.length > 0 ? (<PricingComponent {...this.props} getSubscription={this.getSubscription} style={{ overflowY: 'hidden' }} />) : (
        <div
          className="App"
          style={{ align: "center", position: "relative" }}
        >
          <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
        </div>
      )) : <PaymentNotifierComponent {...this.state} />}
    </div>
  }
}

const mapDispatchToProps = (dispatch) => ({
  getSubscriptionPlans: () => dispatch(PricingActions.getSubscriptionPlans())
}
)
const mapStateToProps = (state, ownProps) => {
  return {
    subscriptionPlans: state.Pricing.subscriptionPlans,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(PricingContainer))
